import {
  ApiClient,
  ApiDeposit,
  ApiLoan,
  ApiMutualFundAssetRead,
  ApiSegregatedPortfolioAssetRead,
  ApiStrategyTemplate
} from 'api/rtk-api'

import { Fee, NumberField } from '../../../types'
import { convertToPercentage } from '../../../util'
import { createClearingRateFee, createFundingRateFee } from '../fees'

export type LeverageVolControlState = {
  fees: Fee[]
  isAllowed: boolean
  leverageRatio: NumberField
  protectionAsset?: ApiMutualFundAssetRead | ApiSegregatedPortfolioAssetRead
  targetVolatility: NumberField
}

function initializeStateFromTemplate(
  template: ApiStrategyTemplate,
  volControl: LeverageVolControlState,
  client: ApiClient,
  cashInstruments: ApiDeposit[] | ApiLoan[]
) {
  volControl.fees.push(
    createClearingRateFee(client.defaultCashInstruments, cashInstruments as ApiDeposit[])
  )
  volControl.fees.push(
    createFundingRateFee(client.defaultCashInstruments, cashInstruments as ApiLoan[])
  )

  volControl.isAllowed = true

  volControl.leverageRatio.min = template.minLeverageRatio
  volControl.leverageRatio.max = template.maxLeverageRatio
  volControl.leverageRatio.value = template.defaultLeverageRatio

  volControl.targetVolatility.min = template.minTargetVolatility
  volControl.targetVolatility.max = template.maxTargetVolatility
  volControl.targetVolatility.value = template.defaultTargetVolatility

  volControl.targetVolatility = convertToPercentage(volControl.targetVolatility)
}

export const leverageVolatilityControl = {
  initializeStateFromTemplate
}
